import { RegisterCard } from "../../components/RegisterCard";
import { CircleLoader } from "../../components/CircleLoader";
import { Heart, Stethoscope, FileText, PlusCircle } from "lucide-react";

export const CAhealth = ({
  formData,
  onFormChange,
  onFormSubmit,
  loading,
}: any) => {
  const healthOptions = [
    {
      id: "good",
      label: "Good",
      color: "bg-emerald-50 text-emerald-700 border-emerald-200",
    },
    {
      id: "sick",
      label: "Sick",
      color: "bg-amber-50 text-amber-700 border-amber-200",
    },
    {
      id: "injured",
      label: "Injured",
      color: "bg-rose-50 text-rose-700 border-rose-200",
    },
  ];

  return (
    <div className="w-full max-w-4xl mx-auto p-4 animate-in fade-in duration-500">
      <RegisterCard
        title="Health Status"
        details="Daily health check shared with parents."
      />

      <form
        onSubmit={onFormSubmit}
        className="mt-6 bg-white rounded-[2.5rem] border border-slate-100 shadow-xl overflow-hidden flex flex-col lg:flex-row"
      >
        <div className="flex-1 p-6 sm:p-10 space-y-8 order-2 lg:order-1">
          {/* Health Status Toggle */}
          <div className="space-y-3">
            <label className="flex items-center gap-2 text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              <Heart size={14} className="text-rose-500" /> Current Condition
            </label>
            <div className="grid grid-cols-3 gap-3">
              {healthOptions.map((opt) => (
                <button
                  key={opt.id}
                  type="button"
                  onClick={() => onFormChange("health", opt.id)}
                  className={`py-3 rounded-2xl border-2 font-bold text-sm transition-all duration-200
                    ${formData["health"] === opt.id ? `${opt.color} ring-4 ring-slate-100` : "bg-slate-50 border-transparent text-slate-400 hover:bg-slate-100"}`}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>

          {/* Observation Select */}
          <div className="space-y-3">
            <label className="flex items-center gap-2 text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              <Stethoscope size={14} className="text-blue-500" /> Clinical
              Observation
            </label>
            <select
              required
              value={formData.observation}
              onChange={(e) => onFormChange("observation", e.target.value)}
              className="w-full h-14 px-5 bg-slate-50 border-2 border-slate-100 rounded-2xl focus:border-blue-500 focus:bg-white transition-all outline-none font-medium text-slate-700"
            >
              <option value="">Choose Observation</option>
              <option value="Normal">Normal Temperature</option>
              <option value="High">High Temperature</option>
              <option value="Pale">Pale Appearance</option>
              <option value="Running Nose">Running Nose</option>
              <option value="Fatigue">Fatigue</option>
            </select>
          </div>

          {/* Description */}
          <div className="space-y-3">
            <label className="flex items-center gap-2 text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              <FileText size={14} className="text-blue-500" /> Detailed Notes
            </label>
            <textarea
              value={formData["description"]}
              onChange={(e) => onFormChange("description", e.target.value)}
              className="w-full p-5 bg-slate-50 border-2 border-slate-100 rounded-[1.5rem] min-h-[120px] focus:bg-white focus:border-blue-500 transition-all outline-none resize-none"
              placeholder="Provide specific details about the child's health..."
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full h-16 bg-slate-900 hover:bg-black text-white rounded-2xl font-black uppercase tracking-widest shadow-lg shadow-blue-900/20 transition-all flex items-center justify-center gap-3"
          >
            {loading ? (
              <CircleLoader />
            ) : (
              <>
                <PlusCircle size={20} /> Add Record
              </>
            )}
          </button>
        </div>

        {/* Sidebar Image */}
        <div className="lg:w-64 bg-slate-50 flex items-center justify-center p-8 order-1 lg:order-2 border-b lg:border-b-0 lg:border-l border-slate-100">
          <img
            src="/img/healthcare.svg"
            className="w-32 h-32 lg:w-48 lg:h-48 drop-shadow-xl animate-float"
            alt="health"
          />
        </div>
      </form>
    </div>
  );
};
